import { ExclamationCircleIcon } from '@heroicons/react/solid'

type TWInputType = {
  name: string,
  label: string,
  value: any,
  handleChange: any,
  error: boolean,
  errorMessage?: string,
  type?: string,
  width?: number
}

export default function TWInput({ name, label, value, handleChange, error, errorMessage, type = 'text', width = 1 }: TWInputType) {
  return (
    <div style={{ flex: 1 }}>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="mt-1 relative rounded-md shadow-sm">
        <input
          type={type}
          name={name}
          id={name}
          className={ error === true ? "block w-full pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm rounded-md" : "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-100 disabled:cursor-not-allowed"}
          placeholder={label}
          value={value}
          onChange={handleChange}
          disabled={name === 'zipCode' || name === 'locality'}
        />
        {error === true && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
          </div>
        )}
      </div>
      {error === true && (
        <p className="mt-2 text-sm text-red-600" id="email-error">{errorMessage}</p>
      )}
    </div>
  )
}